import React, { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useDispatch } from 'react-redux';
import { useFileDownload } from 'requests/resources';

import { ListItem, ListItemText } from '@material-ui/core';
import { ListItemProps } from '@material-ui/core/ListItem';
import { showMessage } from 'actions';

const messages = defineMessages({
  text: {
    id: 'components.v2.ListItemPatientContactsArchived.text',
    defaultMessage: "Download 'Invalid contact' patients",
  },
  messageSuccess: {
    id: 'components.v2.ListItemPatientContactsArchived.tsx.messageSuccess',
    defaultMessage: `We'll send you an email once your download is ready`,
  },
  messageError: {
    id: 'components.v2.ListItemPatientContactsArchived.tsx.messageFail',
    defaultMessage: `There was an error with this download`,
  },
});

export interface ListItemPatientContactsArchivedProps extends Omit<ListItemProps, 'classes'> {}

const ListItemPatientContactsArchived: React.FC<ListItemPatientContactsArchivedProps> = ({
  onClick = () => {},
  ...rest
}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { isSuccess, isError, enabled, setEnabled } = useFileDownload(
    '/v2/patients/reports/archived-contacts-list/xls',
  );

  const clickHandler = () => {
    setEnabled(true);
  };

  const _dispatch = useCallback(
    (message) => {
      dispatch(showMessage(formatMessage(message), 'info'));
    },
    [dispatch, formatMessage],
  );

  useEffect(() => {
    if (isSuccess && enabled) {
      _dispatch(messages.messageSuccess);
    } else if (isError && enabled) {
      _dispatch(messages.messageError);
    }
  }, [isSuccess, isError, enabled, _dispatch]);

  return (
    <ListItem
      button
      onClick={(event) => {
        clickHandler();
        onClick(event);
      }}
      {...rest}
    >
      <ListItemText primary={formatMessage(messages.text)} />
    </ListItem>
  );
};

export default ListItemPatientContactsArchived;
